export default {
    LOAD_CONTENT_SECTIONS (state, contentSections) {
        state.items = contentSections
    },
}